import { additionalPicture } from "./additionalPicture";
import { ApiModel } from "./api-model";

export class additionalPictureRequest extends ApiModel {
  valEmiId: number;
  languageId: number;
  channelId: number;
  destinationId: number;
  setId: number;
  additionalPicture: additionalPicture;
}



// WEBPACK FOOTER //
// ./src/app/models/additionalPictureRequest.ts